import { reactive, ref, computed } from '@vue/composition-api'
import * as apiMyLink from '@/api/my-link'

/**
 * マイリンク一覧
 */
export const getGroup = (props, context) => {
  
  const group1 = reactive({

    list: computed(() => {
      return props.parentMyLinkList
    }),
    
    // 各種ウィンドウ表示フラグ
    visibleMyLinkCreate: false,
    visibleMyLinkEdit: false,
    visibleMyLinkDeleteConfirm: false,
    visibleMyLinkChangePosition: false,

    // マイリンクの編集ウィンドウに値を引き渡すための変数
    myLinkTargetId: 0,
    myLinkTargetTitle: '',
    myLinkTargetURL: '',
    myLinkTargetNewWindow: true,

    // マイリンクの追加ボタン表示フラグ
    isAddButtonShown: computed(() => {
      return (group1.list.length < 10)
    }),

    /**
     * 初期表示
     */
    init: () => {
    },

    /**
     * マイリンクリストをロード（またはリロード）
     */
    loadMyLink: () => {
      // 親ウィンドウのマイリンク一覧をリロード
      context.emit('loadMyLink')
    },

    /**
     * 追加ボタンを押下した場合
     */
    openMyLinkCreate: () => {
      // ウィンドウを表示
      group1.visibleMyLinkCreate = true
    },

    /**
     * 編集ボタンを押下した場合
     */
    openMyLinkEdit: ({ id, title, url, newWindow }) => {
      group1.myLinkTargetId = id
      group1.myLinkTargetTitle = title
      group1.myLinkTargetURL = url
      group1.myLinkTargetNewWindow = newWindow

      // ウィンドウを表示
      group1.visibleMyLinkEdit = true
    },

    /**
     * 並び替えボタンを押下した場合
     */
    openMyLinkChangePosition: ({ id }) => {
      group1.myLinkTargetId = id

      // ウィンドウを表示
      group1.visibleMyLinkChangePosition = true
    },

    /**
     * 削除ボタンを押下した場合
     */
    openMyLinkDeleteConfirm: ({ id }) => {
      group1.myLinkTargetId = id

      // ウィンドウを表示
      group1.visibleMyLinkDeleteConfirm = true
    }

  })

  return group1
}
